// extracted by mini-css-extract-plugin
module.exports = {"ul":"dialogDetailsPure_ul__1pWA2","btnContainer":"dialogDetailsPure_btnContainer__qqnPn","wrapper":"dialogDetailsPure_wrapper__1717q"};